import { StepperLabelEnum } from 'app/modules/widget/enums/stepper-label.enum';

export interface RenewalStep {
  label: string;
}

export function mapSkipPrimeKontentValue(skipPrimeValue?: string): boolean {
  return skipPrimeValue?.toLowerCase() === 'yes';
}

export function filterRenewalStepByLabel<T extends RenewalStep>(
  steps: T[],
  label: StepperLabelEnum
): T[] {
  return steps.filter((step) => step.label !== label);
}

export function reconcileStepIndexAfterRemovingStep(
  stepsBeforeFilter: RenewalStep[],
  filteredSteps: RenewalStep[],
  storedStepIndex: number,
  removedLabel: StepperLabelEnum,
  stepAfterRemoved: StepperLabelEnum = StepperLabelEnum.Pricing
): number {
  const savedLabel =
    stepsBeforeFilter[storedStepIndex]?.label ?? StepperLabelEnum.Welcome;
  const targetLabel =
    savedLabel === removedLabel ? stepAfterRemoved : savedLabel;
  const reconciledIndex = filteredSteps.findIndex(
    (step) => step.label === targetLabel
  );

  return reconciledIndex >= 0 ? reconciledIndex : 0;
}
